import { createBrowserClient } from "@supabase/ssr";
import { getAuthCookieDomain, getAuthCookieName } from "./cookie-domain";
import { purgeStaleAuthCookiesInBrowser } from "./stale-auth-cookies";

export function createClient() {
  const host = typeof window !== "undefined" ? window.location.host : undefined;
  const domain = getAuthCookieDomain(host);
  const cookieName = getAuthCookieName(host);

  purgeStaleAuthCookiesInBrowser();

  const cookieOptions = {
    name: cookieName,
    ...(domain ? { domain, sameSite: "lax" as const } : {}),
    path: "/",
  };

  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_OR_ANON_KEY!,
    { cookieOptions },
  );
}
